export class DateUtils {
  public static isToday (date: Date): boolean {
    const today = new Date()
    return date.getDate() === today.getDate() &&
      date.getMonth() === today.getMonth() &&
      date.getFullYear() === today.getFullYear()
  }

  public static isYesterday (date: Date): boolean {
    const yesterday = new Date(Date.now() - 86400000)
    return date.getDate() === yesterday.getDate() &&
      date.getMonth() === yesterday.getMonth() &&
      date.getFullYear() === yesterday.getFullYear()
  }

  public static dateToEuropeString (date: Date): string {
    return `${date.getDate()}.${date.getMonth() + 1}.${date.getFullYear()}`
  }

  public static dateToMuricaString (date: Date): string {
    return `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`
  }

  public static dateToYodaString (date: Date): string {
    return `${date.getFullYear()}-${(date.getMonth() + 1).toLocaleString('de-DE', { minimumIntegerDigits: 2 })}-${date.getDate().toLocaleString('de-DE', { minimumIntegerDigits: 2 })}`
  }

  public static isoToMysql (iso: string): string {
    const date = new Date(iso)
    return `${date.getDate()}.${date.getMonth() + 1}.${date.getFullYear()} ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`
  }
}
